module.exports = __webpack_public_path__ + "img/cobi.0f15199d.png";